<template>
    <div class="product">
        <!-- @start Produto/Empreendimento -->
        <ui-product-card :unity="unity" :product="product" card footer edit-button />
        <!-- @end Produto/Empreendimento -->


        <!-- @start Valor de Tabela do empreendimento -->
        <div v-if="simulationConfig && parseInt(simulationConfig.unity_value)" class="card card-price table-value">
            <div class="content">
                <div class="title">Valor da Tabela</div>
                <div class="value" data-ui="'simulation-div-unity-cost'" ><small>R$</small> {{ unityCost || '0.00' | currency }}</div>
                <div v-if="showDiscount" class="discount-price" data-ui="'simulation-div-unity-value-discount'">
                    Com desconto {{ unityValueWithDiscount | currencyBRL }}
                    <i class="fas fa-question-circle" hidden />
                </div>
            </div>
            <div v-if="baseCost" class="footer">
                <div class="info" data-ui="'simulation-div-unity-base-cost'">Valor do m²: {{ baseCost | currencyBRL }}</div>
            </div>
        </div>
        <!-- @end Valor de Tabela do empreendimento -->


        <!-- @start Valor de Simulaçãp do Empreendimento -->
        <div v-if="showProposalValue" class="card card-price simulator-value">
            <div class="content">
                <div class="title">Valor da Proposta</div>
                <!-- warning success danger -->
                <div class="value warning" :class="proposedPercentage.missing ? 'warning' : 'success'">
                    <small>R$</small> {{ simulationValue | currency }}
                </div>
                <div  v-if="proposedPercentage.value != 0" class="pending-price" :class="proposedPercentage.missing ? 'danger' : 'success'">
                    <i class="fal fa-hand-holding-usd" />
                    {{ proposedPercentage.missing ? 'Faltam ' : 'Excedeu '}} {{ Math.abs(proposedPercentage.value) | currencyBRL }}&nbsp;({{Math.abs(proposedPercentage.percent.toFixed(2))}}%)
                    <i class="fas fa-question-circle" hidden />
                </div>
                <div  class="progress-bar-container">
                    <div class="progress-bar">
                        <div 
                            class="progress" 
                            :style="{ width: progressPercentage + '%', backgroundColor: '#1CCA85' }"
                        ></div>
                    </div>
                </div>
            </div>
            <div v-if="simulationBaseCost" class="footer">
                <div class="info" data-ui="'simulation-div-base-cost'">Valor do m²: {{ simulationBaseCost | currencyBRL }}</div>
            </div>
        </div>
        <!-- @end Valor de Simulação do Empreendimento -->
    </div>
</template>

<script>
    import uiProductCard from '@/components/ui-facilita/sales/product-card'
    import { currencyBRL } from '@/filters'
    import { mapGetters } from 'vuex'
    import { storage } from '@/services/storage'
    export default {
        name: 'ui-simulation-product',

        components: {
            uiProductCard,
        },

        

        filters: {
            currencyBRL,
            currency(value) {
                if (!value) return ''
                return new Intl.NumberFormat('pt-Br', { style: 'currency', currency: 'BRL', })
                    .format(value)
                    .replace('R$', '')
                    .trim()
            }
        },
        data() {
            return {
                progressValue: 0,
                totalValue: 0,
            }
        },  
   
        computed: {
            ...mapGetters('simulation', {
                baseCost: 'getBaseCost',
                missingValue: 'getMissingValue',
                product: 'getProduct',
                proposedBaseCost: 'getProposedBaseCost',
                proposedFutureBaseCost: 'getProposedFutureBaseCost',
                proposedFutureValue: 'getProposedFutureValue',
                proposedValue: 'getProposedValue',
                simulationConfig: 'getSimulationConfig',
                unity: 'getUnity',
                unityCost: 'getUnityCost',
                unityValueWithDiscount: 'getUnityValueWithDiscount',
                proposedPercentage: 'getProposedPercent',
            }),
            progressPercentage() {
                if (this.proposedPercentage.missing) {
                    return 100 + (this.proposedPercentage.percent);
                }
                return 100 - (this.proposedPercentage.percent * -1);
            }, 
            /**
             * Computed property para, dependendo da configuração, mostrar o valor presente ou
             * futuro como o montante da simulação
             */
            simulationValue() {
                return this.simulationConfig && this.simulationConfig.future_value && !!parseInt(this.simulationConfig.future_value)
                     ? this.proposedFutureValue
                     : this.proposedValue;
            },

            /**
             * Computed property para, dependendo da configuração, mostrar o valor da metragem
             * calculado com relação ao valor presente ou futuro da simulação
            */
            simulationBaseCost() {
                return this.simulationConfig && parseInt(this.simulationConfig.future_value)
                    ? this.proposedFutureBaseCost
                    : this.proposedBaseCost
            },

            /**
             * Computed property que define se o valor da unidade com desconto deve ser mostrado ou não
             */
            showDiscount() {
                return parseFloat(this.unityCost) !== parseFloat(this.unityValueWithDiscount)
            },
            generalSimulationConfigs(){
                return JSON.parse(storage.get('proposal_settings'))
            },  
            showProposalValue(){
              //Caso exista a configuração do empreendimento individual, o this.simulationConfig.configuration será 1 e caso exista o proposal_value configurado, entrará nessa condicional
              //Nesse fluxo irá respeitar a configuração do empreendimento individual caso exista a configuração habilitada e caso exista configuração da exibição do valor da proposta
              //Lembrando que é necessário relogar pra que a configuração seja atualizada, seria interessante mudar esse fluxo, porém teria um impacto grande no sistema, é necessário avaliar 
                if(parseInt(this.simulationConfig?.configuration) && this.simulationConfig.hasOwnProperty('proposal_value') ){
                    ///Caso exista a configuração proposal_value e ela seja 1, exibe o valor da proposta
                    if(this.simulationConfig.hasOwnProperty('proposal_value') && Boolean(parseInt(this.simulationConfig.proposal_value))) return true;
                    ///Por padrão retorna false pra atender o caso de não existir ou não ser configurado
                    return false;
                }
                ///Caso não exista a configuração do empreendimento individual, respeita a configuração global
                //Caso não exista a configuração ou seja,mesmo se estiver marcado como não, cai no caso do usuário nunca ter configurado, então exibe o valor da proposta
                if(!this.generalSimulationConfigs?.simulation?.hasOwnProperty('proposal_value')) return true;
                //Caso exista a configuração e ela foi marcada como não, ou seja o cliente salvou como não, então não exibe o valor da proposta
                if(!parseInt(this.generalSimulationConfigs?.simulation?.proposal_value)) return false;
                //Por padrão retorna true pra mostrar o valor pra caso não cair em nenhum caso, pra atender todos clientes que nunca configuraram nada relacionado ao valor da proposta
                return true
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>